import React from 'react'
import ReactSelect from 'react-select'


export const SelectBox = ({
  indicatorContainerStyles = {},
  valueContainerStyles = {},
  controlStyles = {},
  optionStyles = {},
  getOptionLabel,
  defaultValue,
  borderColor,
  className,
  textColor,
  boxShadow,
  valueKey='value',
  labelKey='label',
  onChange,
  type,
  list = [],
  avatarImg='',
  ...rest
}) => {


  return (
    <ReactSelect
      options={list}
      getOptionLabel={getOptionLabel || ((option) => <div {...option?.props} className="item-label"> {option.label} </div>)}
      onChange={onChange}
      value={list[defaultValue] || list[0]}
      maxMenuHeight={300}
      menuPlacement="bottom"
      {...rest}
      styles={{
        menu: (provided) => ({
          ...provided,
          minWidth: 'max-content',
          width: type === 'outline' ? 100 : '100%',
          marginLeft: avatarImg.className? '-50%': '0px',
          zIndex: 9999,
          position: 'absolute',
          top: '100%',
          left: 0
        }),
        control: (provided, state) => ({
          ...provided,
          minHeight: 30,
          background: 'transparent',
          border: type === 'outline' ? 0 : `1px solid ${borderColor || 'var(--primary-dark-blue)'}`,
          borderBottom: `1px solid ${borderColor || 'var(--primary-dark-blue)'}`,
          borderRadius: type === 'outline' ? 0 : 5,
          boxShadow: boxShadow || (state.menuIsOpen && type !== 'outline' && '0 0 0 1px var(--primary-dark-blue)'),
          width: type === 'outline' && 100,
          minWidth: '55px',
          position: 'relative',
          '&:hover': { borderColor: borderColor || 'var(--primary-dark-blue)' },
          ...controlStyles
        }),
        menuList: (provided) => ({
          ...provided,
          padding: 0,
          borderRadius: 5,
          color: textColor || 'var(--primary-dark-blue)'
        }),
        indicatorSeparator: () => ({
          display: 'none'
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          display: avatarImg ? 'none': 'block',
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          '& div[class*="indicatorContainer"]': { padding: '6px 8px' },
          ...indicatorContainerStyles,
        }),
        option: (provided, state) => ({
          ...provided,
          background: state.isSelected && 'var(--primary-dark-blue)',
          margin: 0,
          '&:hover': {
            cursor: 'pointer',
            background: !state.isSelected && '#0f3d5622',
          },
          '&:active': {
            background: '#0b2736',
            color: '#fff'
          },
          '& .item-label': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          ...optionStyles
        }),
        singleValue: (provided) => ({
          ...provided,
          color: textColor || 'var(--primary-dark-blue)',
          fontWeight: type === 'outline' ? 600 : 500,
          '& .item-label': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': {
              display: 'none'
            }
          },
        }),
        valueContainer: (provided) => ({
          ...provided,
          ...valueContainerStyles
        })
      }}
      isSearchable={false}
      className={className}
    />
  )
}